export default {
    courses: 'Basic Courses',
    finalquiz: 'Final Tests',
    back_to_menu: 'Back to courses',
    home: 'Home',
    new_chapter: 'new chapter',
    new_chapter_plural: 'new chapters'
}
